<form [formGroup]="skjema" (ngSubmit)="lagre()" data-testid="avstemningskjema">
  <mat-toolbar color="primary">
    <span id="rediger-avstemning-dialog-tittel">
      @if (modus === 'rediger') {
        {{ 'Rediger avstemning'|translate }}
      } @else {
        {{ 'Ny avstemning'|translate }}
      }
    </span>
    <button mat-icon-button type="button" aria-label="Lukk dialog" (click)="avbryt()">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <mat-form-field class="avstemningstittel">
      <mat-label>{{ 'Avstemningstittel'|translate }}</mat-label>
      <input matInput [formControl]="skjema.controls.tittel" name="tittel" data-testid="tittel-felt">
      @if (skjema.controls.tittel.hasError('maxlength')) {
        <mat-error data-testid="maxlength">{{ skjema.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'Beskrivelse'|translate }}</mat-label>
      <riktekst-redigering [skjemakontroll]="skjema.controls.beskrivelse" [gruppeId]="gruppeId" name="beskrivelse" data-testid="beskrivelse-felt"/>
    </mat-form-field>
    <ramme-med-tittel tittel="{{ 'Avstemningsalternativer'|translate }}*">
      <ramme-innhold>
        <div class="alternativer">
          @for (alternativ of skjema.controls.alternativer.controls; track indeks; let indeks = $index; let erSisteRad = $last) {
            <mat-form-field class="full-width no-subscript-wrapper" [attr.data-testid]="alternativ.value.id ? 'alternativ-tittel' : 'nytt-alternativ-tittel'">
              <input matInput type="text" [formControl]="alternativ.controls.tittel" [name]="'alternativ-' + $index" placeholder="{{'Skriv inn nytt alternativ...'|translate}}">
              @if (alternativ.controls.tittel.hasError('maxlength')) {
                <mat-error data-testid="maxlength">{{ alternativ.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
              }
            </mat-form-field>
            <!-- viser ikke slett-knapp for siste rad -->
            @if (!erSisteRad) {
              <button mat-icon-button type="button" (click)="slettAlternativt(indeks)" [matTooltip]="'Slett alternativ' | translate" [disabled]="erSisteRad">
                <mat-icon>delete</mat-icon>
              </button>
            }
          }
        </div>
        <!-- ikke vis feilmelding før bruker har vært innom minst ett av feltene i skjemaet -->
        @if (skjema.touched && skjema.controls.alternativer.hasError('listeMedMinimumslengde')) {
          <div class="for-få-alternativer" data-testid="listeMedMinimumslengde">{{ 'Minst ett avstemningsalternativ må være angitt' | translate }}</div>
        }
      </ramme-innhold>
    </ramme-med-tittel>
  </mat-dialog-content>

  <mat-dialog-actions align="start">
    <button mat-raised-button color="primary" type="submit" [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()">
      {{ 'Lagre'|translate }}
    </button>
    <button mat-button type="button" (click)="avbryt()" [disabled]="lagrer()">{{ 'Avbryt'|translate }}</button>
  </mat-dialog-actions>
</form>
